export const dot = (color = "#ccc") => ({
  alignItems: "center",
  display: "flex",
  maxWidth: "100%",

  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10,
  },
});
